
var id = "uploadFile";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"uploadFile\">\n<path d=\"M7.99996 14.6666H3.33329C2.9651 14.6666 2.66663 14.3681 2.66663 13.9999V1.99992C2.66663 1.63173 2.9651 1.33325 3.33329 1.33325H12.6666C13.0348 1.33325 13.3333 1.63173 13.3333 1.99992V7.99993\" stroke=\"#333333\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M11.8333 14.6666V10.3333\" stroke=\"#333333\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M10.3333 11.4999L10.8333 10.9999L11.8333 9.99988L12.8333 10.9999L13.3333 11.4999\" stroke=\"#333333\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M5.33325 5.33325H10.6666\" stroke=\"#333333\" stroke-width=\"1.33333\" stroke-linecap=\"round\" />\n<path d=\"M5.33325 7.99988H7.99992\" stroke=\"#333333\" stroke-width=\"1.33333\" stroke-linecap=\"round\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
